<template>
  <a :href="url" :class="$style.helpCentreItem" @click="$emit('click')">
    <slot name="image" />
    <div class="h-full">
      <slot name="title" />
      <slot name="description" />
    </div>
  </a>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "NavHelpCentreItem",
  props: {
    url: {
      type: String,
      default: ""
    },
    imageSrc: {
      type: String,
      default: null
    }
  }
})
</script>

<style lang="scss" module>
.helpCentreItem {
  @apply flex flex-row gap-ds-md items-center justify-between cursor-pointer text-base-dark no-underline w-full hover:no-underline hover:text-base-dark focus:no-underline focus:text-base-dark;

  img {
    @apply w-full max-w-[72px] h-[72px] object-cover rounded-md self-start min-h-0;
  }

  div {
    @apply flex flex-col gap-ds-xxs justify-start;

    p:first-of-type {
      @apply text-sm font-bold no-underline mb-0;
    }

    p:last-of-type {
      @apply text-xs opacity-50 no-underline;
    }
  }
}
</style>
